var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0007 0.334636C26.1376 0.334635 33.6673 7.87785 33.6673 16.9926C33.6673 26.1248 26.1201 33.668 17.0007 33.668C7.86368 33.668 0.333984 26.1248 0.333983 16.9926C0.333983 7.87785 7.88115 0.334636 17.0007 0.334636Z",
    fill: "#282829",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.174 10.2351C12.7373 9.81608 12.7373 9.10017 13.1915 8.64618C13.5759 8.2795 14.3446 8.29696 14.7638 8.69856L21.9616 15.5433C22.8002 16.3116 22.8002 17.6387 21.9616 18.4244L14.7638 25.2517C14.2921 25.6883 13.6283 25.7232 13.1915 25.3041C12.7373 24.8851 12.7373 24.1517 13.174 23.7326L20.2845 16.9926L13.174 10.2351Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrow);
export default __webpack_public_path__ + "static/media/sliderArrow.5b96ed5d57c16d5da8ed930a3059578b.svg";
export { ForwardRef as ReactComponent };